import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TextField } from "@mui/material";

type Props = {
  open: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  confirmColor?: "primary" | "error" | "warning";
  requireReason?: boolean;
  onClose: () => void;
  onConfirm: (reason?: string) => Promise<void> | void;
};

const ConfirmDialog: React.FC<Props> = ({ open, title, message, confirmLabel = "Confirm", confirmColor = "primary", requireReason, onClose, onConfirm }) => {
  const [busy, setBusy] = React.useState(false);
  const [reason, setReason] = React.useState("");

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: requireReason ? 2 : 0 }}>{message}</Typography>
        {requireReason && (
          <TextField
            fullWidth multiline minRows={2}
            label="Reason"
            value={reason} onChange={(e) => setReason(e.target.value)}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={busy}>Cancel</Button>
        <Button variant="contained" color={confirmColor} disabled={busy || (requireReason && reason.trim().length === 0)}
          onClick={async () => {
            setBusy(true);
            try { await onConfirm(reason); } finally { setBusy(false); }
          }}
        >
          {busy ? "Working…" : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
